// removed by extract-text-webpack-plugin
module.exports = {"SettingsView":"SettingsView--3CFpc"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Settings/SettingsView.scss
// module id = 955
// module chunks = 1